export enum RequestType {
  CALL = 'CALL',
  REGISTER = 'REGISTER'
}
